import { useState, useEffect } from "react";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ChargerContext } from "../../context/ChargerContext";
import { OnlineStatusContext } from "../../context/OnlineStatusContext";
import { useConfig } from "../../context/configContext";
import { getChargerProfile } from "../../services/chargerApi";
import { FaCaretDown, FaCaretRight } from "react-icons/fa6";
import api from "../interceptors";
import "./Maplist.css";

const TreeRow = ({ open, label, onClick }) => (
  <button
    type="button"
    className={`station-tree-row ${open ? "is-open" : ""}`}
    onClick={onClick}
  >
    {open ? <FaCaretDown /> : <FaCaretRight />}
    <span>{label}</span>
  </button>
);

const StationRow = ({ label, onClick }) => (
  <button type="button" className="station-row" onClick={onClick}>
    <span>{label}</span>
  </button>
);

const ListView = ({ searchTerm, searchResults, selectedLocation }) => {
  const [cpos, setCpos] = useState([]);
  const [treeData, setTreeData] = useState({});
  const [openNodes, setOpenNodes] = useState({});
  const { updateConfig } = useConfig();
  const { setChargerData } = useContext(ChargerContext);
  const { setonlineStatus } = useContext(OnlineStatusContext);
  const navigate = useNavigate();

  // const getFilteredTree = () => {
  //   if (!searchTerm) return [];

  //   return searchResults.map((loc) => ({
  //     cpo: loc.customer_id,
  //     country: loc.country,
  //     state: loc.state,
  //     district: loc.district,
  //     station: loc.station_id,
  //   }));
  // };
  const buildFilteredTree = () => {
    if (!selectedLocation) return null;
    console.log(selectedLocation);

    const {
      customer_id,
      country,
      state,
      state_district,
      station_id,
      customer_name,
    } = selectedLocation;

    return {
      [`${customer_id} (${customer_name})`]: {
        [country]: {
          [state]: {
            [state_district]: [
              {
                station_id,
                customer_id,
              },
            ],
          },
        },
      },
    };
  };
  const filteredTree = buildFilteredTree();
  const isSearching = filteredTree !== null;

  const handleStationClick = async (station) => {
    console.log(station);
    try {
      const response = await getChargerProfile({
        customer_id: station.customer_id,
        station_id: station.station_id,
      });

      if (!response.success) return;

      const profile = response.data;

      // store full profile
      setChargerData(profile);

      // fetch online status
      const statusRes = await api.get(
        `/api/get_online_status?station_id=${profile.station_id}`,
      );
      const statusData =  statusRes.data;

      setonlineStatus(
        statusData.dispensers.map((d) => ({
          [d.dispensor_id]: d.status,
        })),
      );

      // stats
      const totalDispensers = profile.dispensers.length;
      const totalGuns = profile.dispensers.reduce(
        (sum, d) => sum + (d.guns?.length || 0),
        0,
      );

      // update config
      updateConfig({
        dispensers: totalDispensers,
        guns: totalGuns,
        station_id: profile.station_id,
        station_name: profile.station_name,
        customer_id: profile.customer_id,
        cpo_name: profile.cpo_name,
        dispensersData: profile.dispensers,
        status: "ONLINE", // or derive if available
      });

      // redirect
      navigate("/");
    } catch (err) {
      console.error("Station selection failed:", err);
    }
  };

  const toggleFilteredNode = (key) => {
    setOpenNodes((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  useEffect(() => {
    const fetchCpos = async () => {
      const res = await api.get("/api/get_cpo_details");
      const data = res.data;
      console.log(data);
      setCpos(data.data || []);
    };
    fetchCpos();
  }, []);



  const toggleNode = async (type, value, parent = {}) => {
    const key = `${type}-${value}-${JSON.stringify(parent)}`;

    // toggle open/close
    setOpenNodes((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));

    // already fetched
    if (treeData[key]) return;

    let url = "";

    if (type === "cpo") {
      url = `/api/get_countries?cpo=${value}`;
    }
    if (type === "country") {
      url = `/api/get_states?cpo=${parent.cpo}&country=${value}`;
    }
    if (type === "state") {
      url = `/api/get_districts?cpo=${parent.cpo}&country=${parent.country}&state=${value}`;
    }
    if (type === "district") {
      url = `/api/get_stations?cpo=${parent.cpo}&country=${parent.country}&state=${parent.state}&district=${value}`;
    }

    try {
      const res = await api.get(url);
      const data = res.data;

      setTreeData((prev) => ({
        ...prev,
        [key]: data.data || data || [],
      }));
    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  const renderFilteredTree = (tree) => {
    console.log(tree);
    return Object.keys(tree).map((cpo) => {
      const cpoKey = `cpo-${cpo}`;
      const cpoOpen = openNodes[cpoKey];

      return (
        <div key={cpo} className="station-node">
          {/* CPO */}
          <TreeRow
            open={cpoOpen}
            label={cpo}
            onClick={() => toggleFilteredNode(cpoKey)}
          />

          {cpoOpen &&
            Object.keys(tree[cpo]).map((country) => {
              const countryKey = `country-${cpo}-${country}`;
              const countryOpen = openNodes[countryKey];

              return (
                <div key={country} className="station-node-children">
                  {/* Country */}
                  <TreeRow
                    open={countryOpen}
                    label={country}
                    onClick={() => toggleFilteredNode(countryKey)}
                  />

                  {countryOpen &&
                    Object.keys(tree[cpo][country]).map((state) => {
                      const stateKey = `state-${cpo}-${country}-${state}`;
                      const stateOpen = openNodes[stateKey];

                      return (
                        <div key={state} className="station-node-children">
                          {/* State */}
                          <TreeRow
                            open={stateOpen}
                            label={state}
                            onClick={() => toggleFilteredNode(stateKey)}
                          />

                          {stateOpen &&
                            Object.keys(tree[cpo][country][state]).map(
                              (district) => {
                                const districtKey = `district-${cpo}-${country}-${state}-${district}`;
                                const districtOpen = openNodes[districtKey];

                                return (
                                  <div
                                    key={district}
                                    className="station-node-children"
                                  >
                                    {/* District */}
                                    <TreeRow
                                      open={districtOpen}
                                      label={district}
                                      onClick={() =>
                                        toggleFilteredNode(districtKey)
                                      }
                                    />

                                    {districtOpen &&
                                      tree[cpo][country][state][district].map(
                                        (station) => (
                                          <StationRow
                                            key={station.station_id}
                                            label={station.station_id}
                                            onClick={() =>
                                              handleStationClick(station)
                                            }
                                          />
                                        ),
                                      )}
                                  </div>
                                );
                              },
                            )}
                        </div>
                      );
                    })}
                </div>
              );
            })}
        </div>
      );
    });
  };

  const renderNodes = (type, items, parent = {}) => {
    return items.map((item) => {
      const value = type === "cpo" ? item.customer_id : item;
      const label =
        type === "cpo" ? `${item.customer_id} (${item.name})` : item;
      const key = `${type}-${value}-${JSON.stringify(parent)}`;
      const isOpen = openNodes[key];
      const children = treeData[key] || [];

      let nextType =
        type === "cpo"
          ? "country"
          : type === "country"
            ? "state"
            : type === "state"
              ? "district"
              : "station";

      const nextParent = {
        cpo: parent.cpo || value,
        country: parent.country || (type === "country" ? item : undefined),
        state: parent.state || (type === "state" ? item : undefined),
      };

      return (
        <div key={key}>
          <button
            type="button"
            onClick={() => toggleNode(type, value, parent)}
            className={`station-tree-row ${isOpen ? "is-open" : ""}`}
          >
            <span>{isOpen ? <FaCaretDown /> : <FaCaretRight />}</span>
            <span>{label}</span>
          </button>

          {isOpen && children.length > 0 && (
            <div className="station-node-children">
              {nextType === "station"
                ? children.map((station) => {
                    const stationId = station.split(" - ")[0];
                    return (
                      <StationRow
                        key={station}
                        label={station}
                        onClick={() =>
                          handleStationClick({
                            station_id: stationId,
                            customer_id: parent.cpo, // assuming cpo = customer_id
                          })
                        }
                      />
                    );
                  })
                : renderNodes(nextType, children, nextParent)}
            </div>
          )}
        </div>
      );
    });
  };

  return (
    <div className="station-list-shell hide-scrollbar">
      <div className="station-list-panel">
        <div className="station-list-header">
          <div>
            <p>{isSearching ? "Search result" : "Station network"}</p>
            <h2>{isSearching ? "Matched charger location" : "Browse chargers"}</h2>
          </div>
          <span className="station-list-count">
            {isSearching ? "Filtered" : `${cpos.length} CPOs`}
          </span>
        </div>

        <div className="station-list-tree hide-scrollbar">
          {isSearching
            ? renderFilteredTree(filteredTree)
            : cpos.length > 0
              ? renderNodes("cpo", cpos)
              : <div className="station-list-empty">Loading stations...</div>}
        </div>
      </div>
    </div>
  );
};

export default ListView;
